<template>
  <div class="bg">
    <div class="warpperBox">
      <div class="infLine borderB">
        提现至{{ detail.bankName
        }}<span class="infText" v-if="detail.accountNumber"
          >（尾号{{ detail.accountNumber.substr(-4) }}）</span
        >
      </div>
      <div class="infLine borderB">
        <div class="inputWrapper flex">
          <div style="font-size: 30px;">￥</div>
          <div class="flex1">
            <input
              class="infInput"
              v-model="params.amount"
              placeholder="请输入提现金额"
            />
          </div>
          <div class="allWithdraw" v-if="detail.details" @click="allWithdraw">
            全部提现
          </div>
        </div>
      </div>
      <div class="infLine" style="font-size: 12px;">
        可提现金额：<span v-if="detail.details">{{
          detail.details[0].availableAmount
        }}</span
        >元
      </div>
    </div>
    <div class="warpperBox">
      <div class="infLine borderB" style="font-size: 15px;padding: 15px 20px;">
        向联系人预留手机号<span v-if="detail.phone"
          >（尾号{{ detail.phone.substr(-4) }}) </span
        >发送验证码
      </div>
      <div class="infLine flex" style="padding: 10px 20px;">
        <div class="title">验证码</div>
        <div class="flex1">
          <input class="lineInput" v-model="code" placeholder="请输入验证码" />
        </div>
        <div
          class="codeButton"
          :class="{ disabled: isDisable }"
          @click="getCode"
        >
          {{ getMobileCodeText() }}
        </div>
      </div>
    </div>
    <div class="confirmButton" @click="confirmWithdraw">确认提现</div>
  </div>
</template>

<script>
import {
  getAccountDetail,
  withdrawCodeFetch,
  withdrawApply,
  withdrawCodeVerify
} from "../../api/bank.js";

export default {
  data() {
    return {
      wait_timer: false,
      isDisable: false,
      detail: "",
      params: {
        amount: "",
        bankCardId: "",
        requestNo: new Date().getTime(),
        codeRequestNo: "",
        commission: "",
        withdrawForm: "VERIFICATION",
        withdrawType: "URGENT"
      },
      code: ""
    };
  },
  created() {
    this.getAccountDetail(this.$route.query.id);
    this.params.bankCardId = this.$route.query.id;
  },
  methods: {
    allWithdraw() {
      this.params.amount = this.detail.details[0].availableAmount;
    },
    async confirmWithdraw() {
      await this.withdrawCodeVerify();
      this.$vux.loading.show();
      withdrawApply(this.params)
        .then(() => {
          this.$vux.loading.hide();
          this.$router.push({ path: "/bankCard//bankCard" });
        })
        .catch(err => {
          this.$vux.loading.hide();
          this.$showMessage(err);
        });
    },
    withdrawCodeVerify() {
      withdrawCodeVerify({
        codeRequestNo: this.params.codeRequestNo,
        verificationCode: this.code
      })
        .then(res => {
          console.log(res);
        })
        .catch(err => {
          this.$showMessage(err);
        });
    },
    getAccountDetail(id) {
      getAccountDetail({ id: id })
        .then(res => {
          this.detail = res;
        })
        .catch(err => {
          this.$showError(err);
        });
    },
    getCode() {
      let that = this;

      this.wait_timer = 59;
      this.isDisable = true;
      let timer_interval = setInterval(function() {
        if (that.wait_timer > 0) {
          that.wait_timer--;
        } else {
          that.isDisable = false;
          clearInterval(timer_interval);
        }
      }, 1000);
      withdrawCodeFetch({
        bankCardId: this.params.bankCardId,
        requestNo: this.params.requestNo
      })
        .then(res => {
          this.params.codeRequestNo = res.requestNo;
        })
        .catch(err => {
          this.wait_timer = false;
          this.isDisable = false;
          this.$showMessage(err);
        });
    },
    getMobileCodeText() {
      if (this.wait_timer > 0) {
        return this.wait_timer + "s后获取";
      }

      if (this.wait_timer === 0) {
        return "重新获取";
      }

      if (this.wait_timer === false) {
        return "获取验证码";
      }
    }
  }
};
</script>

<style>
input {
  border: none;
}
.allWithdraw {
  width: 180px;
  height: 60px;
  line-height: 56px;
  text-align: center;
  font-size: 14px;
  color: #fff;
  background: #007bec;
  border-radius: 10px;
  margin-left: 20px;
}
.bg {
  background: #f3f3f3;
}
.warpperBox {
  background: #fff;
  margin: 20px 0;
  overflow: hidden;
}
.borderB {
  border-bottom: 2px solid #e8e8e8;
}
.infLine {
  padding: 40px;
  font-size: 15px;
}
.infText {
  color: #a8abb4;
  font-size: 12px;
}
.inputWrapper {
  padding: 30px 0;
  height: 60px;
  line-height: 60px;
}
.infInput {
  height: 60px;
  line-height: 60px;
  font-size: 14px;
}
.title {
  font-size: 15px;
  height: 56px;
  line-height: 56px;
}
.lineInput {
  height: 56px;
  line-height: 56px;
  text-align: right;
  color: #474747;
  font-size: 14px;
}
.codeButton {
  width: 180px;
  height: 56px;
  line-height: 56px;
  text-align: center;
  font-size: 14px;
  color: #fff;
  background: #007bec;
  border-radius: 10px;
  margin-left: 20px;
}
.confirmButton {
  margin: 90px 30px 0 30px;
  background: #007bec;
  height: 88px;
  line-height: 88px;
  text-align: center;
  color: #fff;
  border-radius: 10px;
  font-size: 16px;
}
</style>
